import { Link } from "react-router-dom";
import { PAGES, routesConfig } from "../../routeConfig";
import { useAuth } from "../../Context/AuthContext";
import { handleCloseSideBar } from "../Common/common";

export const MyAccountMenuList = () => {
  const { role, isBrowseOnly } = useAuth();
  return (
    <div className="dropdown-myAcconunt-content">
      {/* Browse-only users can only reach My Account Details / Change Password / Change Username. */}
      {!isBrowseOnly && (
        <div className="dropdownAccount-list">
          <h6>My Orders</h6>
          <ul className="m-0 p-0">
            <li>
              <Link onClick={handleCloseSideBar} className="" to={PAGES.ORDERHISTORY}>
                <span className="wes-buying-option jump-spin" />
                Order History
              </Link>
            </li>
            <li>
              <Link onClick={handleCloseSideBar} className="" to={PAGES.FAVORITEPRODUCT_LIST}>
                <span className="wes-whishlist1 jump-spin" />
                My Favourite Products
              </Link>
            </li>
            <li>
              <Link onClick={handleCloseSideBar} className="" to={PAGES.PENDINGORDERS}>
                <span className="wes-bag-timer jump-spin" />
                My User Pending Orders
              </Link>
            </li>
          </ul>
        </div>
      )}
      <div className="dropdownAccount-list">
        <h6>My Account</h6>
        <ul className="m-0 p-0">
          <li>
            <Link onClick={handleCloseSideBar} className="" to={PAGES.MYACCOUNTDETAIL}>
              <span className="wes-profile-tick jump-spin" />
              My Account Details
            </Link>
          </li>
          {!isBrowseOnly && (
            <li>
              <Link onClick={handleCloseSideBar} className="" to={PAGES.MYWALLET}>
                <span className="wes-wallet-minus jump-spin" />
                My Wallet
              </Link>
            </li>
          )}
          {!isBrowseOnly && role == 1 && (
            <li>
              <Link onClick={handleCloseSideBar} className="" to="/myaccount/company-users">
                <span className="wes-company jump-spin" />
                My Company Users
              </Link>
            </li>
          )}
          {!isBrowseOnly && (
            <li>
              <Link onClick={handleCloseSideBar} className="" to={PAGES.MYADDRESSBOOK}>
                <span className="wes-catalogue jump-spin" />
                Shipping Address Book
              </Link>
            </li>
          )}
          {!isBrowseOnly && (
            <li>
              <Link onClick={handleCloseSideBar} className="" to={PAGES.PAYACCOUNT}>
                <span className="wes-profile-tick jump-spin" />
                Pay Account
              </Link>
            </li>
          )}
        </ul>
      </div>
      <div className="dropdownAccount-list">
        <h6>Settings</h6>
        <ul className="m-0 p-0">
          {!isBrowseOnly && (
            <li>
              <Link onClick={handleCloseSideBar} className="" to="/myaccount/website-settings">
                <span className="wes-monitor-mobbile jump-spin" />
                Web site settings
              </Link>
            </li>
          )}
          <li>
            <Link onClick={handleCloseSideBar} className="" to="/myaccount/change-password">
              <span className="wes-lock jump-spin" />
              Change Password
            </Link>
          </li>
          <li>
            <Link onClick={handleCloseSideBar} className="" to="/myaccount/change-username">
              <span className="wes-user-edit1 jump-spin" />
              Change Username
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};
